var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHotWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74706 10H4.93106V7.44H7.17106V10H8.34706V4.08H7.17106V6.416H4.93106V4.08H3.74706V10ZM11.6738 10.112C13.2418 10.112 14.3138 8.944 14.3138 7.016C14.3138 5.096 13.2418 3.976 11.6738 3.976C10.0978 3.976 9.02575 5.088 9.02575 7.016C9.02575 8.944 10.0978 10.112 11.6738 10.112ZM11.6738 9.088C10.7858 9.088 10.2338 8.28 10.2338 7.016C10.2338 5.752 10.7858 4.992 11.6738 4.992C12.5538 4.992 13.1137 5.752 13.1137 7.016C13.1137 8.28 12.5538 9.088 11.6738 9.088ZM15.8849 10H17.0689V5.064H18.7409V4.08H14.2129V5.064H15.8849V10Z",
    fill: "#E7321A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotWord);
export default __webpack_public_path__ + "static/media/icon_hot_word.deafe119394f74377754beb2193c84d2.svg";
export { ForwardRef as ReactComponent };